import './public-path';
import React, { Fragment, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { isDev, microAppRewrite, ThemeProvider, Themes } from '@maxtropy/components';
import './index.scss';
import App from './App';
import 'dayjs/locale/zh-cn';
// polyfill，兼容低版本浏览器
import 'core-js/stable';
import 'core-js/features/array/at';
import 'core-js/features/string/at';
import 'regenerator-runtime/runtime';

microAppRewrite();

const container = document.getElementById('root');
const root = createRoot(container!);
const StrictModeComponent = isDev() ? Fragment : StrictMode;
const theme = window.THEME === Themes.LIGHT ? Themes.LIGHT : Themes.DARK;

root.render(
  <StrictModeComponent>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </StrictModeComponent>
);
